import React from 'react';
import { useTheme } from '@material-ui/core';

interface PayFullBillProps {
  className?: string;
}

const PayFullBill = ({ className }: PayFullBillProps) => {
  const {
    success: { main },
    primary: { main: primaryMain },
    common: { white },
  } = useTheme().palette;

  return (
    <svg
      width="106"
      height="107"
      viewBox="0 0 106 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M29 24.5L23 18.5V91.5H83V18.5L77 24.5L71 18.5L65 24.5L59 18.5L53 24.5L47 18.5L41 24.5L35 18.5L29 24.5Z"
        fill={primaryMain}
      />
      <circle cx="53" cy="55.5" r="17" fill={main} />
      <path
        d="M46 57.2222L50.2 61.5L61 50.5"
        stroke={white}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PayFullBill;
